import _ from 'lodash'
import { Segment, Header, List, Image } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const Feta = () => {
  const { t } = useTranslation('common')
  return (
    <Segment basic padded>
      <Header
        textAlign='center'
        as='h2'
        content={t('products.feta.name')}
        // subheader={t('products.feta.subtitle')}
      />
      <Segment basic clearing>
        <Image src='/p2-1.jpg' size='large' floated='left' />
        <p>{t('products.feta.desc.p1')}</p>
        <p>{t('products.feta.desc.p2')}</p>
      </Segment>

      <List relaxed bulleted>
        {_.map(_.range(16), (i) => (
          <List.Item key={i}>{t(`products.feta.list.i${i + 1}`)}</List.Item>
        ))}
      </List>
    </Segment>
  )
}

export default Feta
